import {useCallback, useEffect, useState} from 'react';

const apiURL = process.env.REACT_APP_API_URL;

export function usePublicTiersPayant(token) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`${apiURL}/api/public/tiers-payant/${token}`);
            if (res.status === 404) {
                setError({code: 'not_found'});
            } else if (res.status === 410) {
                setError({code: 'closed'});
            } else if (!res.ok) {
                setError({code: 'unknown'});
            } else {
                setData(await res.json());
            }
        } catch (e) {
            setError({code: 'network'});
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => { fetchData(); }, [fetchData]);

    const submit = useCallback(async (payload) => {
        const formData = new FormData();
        if (payload.invoiceNumber) formData.append('invoiceNumber', payload.invoiceNumber);
        if (payload.comment) formData.append('comment', payload.comment);
        (payload.files || []).forEach((file, idx) => formData.append(`file_${idx}`, file));

        const res = await fetch(`${apiURL}/api/public/tiers-payant/${token}/submit`, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            return {ok: false, status: res.status, errors: body.errors || {}};
        }
        await fetchData();
        return {ok: true};
    }, [token, fetchData]);

    const alert = useCallback(async ({comment}) => {
        try {
            const res = await fetch(`${apiURL}/api/public/tiers-payant/${token}/alert`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({comment}),
            });
            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                return {ok: false, status: res.status, errors: body.errors || {}};
            }
            await fetchData();
            return {ok: true};
        } catch (e) {
            return {ok: false, status: 0, errors: {network: 'error'}};
        }
    }, [token, fetchData]);

    return {data, loading, error, submit, alert};
}
